module.exports = __webpack_public_path__ + "0c3a8b3c44d1c0ac0e10bb7839944028.svg";